import React, {Component} from 'react';
import './ErrorPage.css';

class ErrorPage extends Component {
	render() {
		return <main className={`ErrorPage ${this.props.className || ''}`}>{this.props.children}</main>;
	}
}

export default ErrorPage;



// WEBPACK FOOTER //
// ./src/widgets/ErrorPage.js